<div id="map" style="height: 100%;"></div>
